import { isServerSideRender } from 'utils'
import { useLayoutEffect } from 'react'

export const useBrowserLayoutEffect = isServerSideRender() ? () => undefined : useLayoutEffect
